<template>
  <div class="tw-w-100 tw-h-full tw-text-gray-900 tw-mb-20">
    <!-- <b-btn @click="doSomething">Map</b-btn> -->
    <h2>Cluster Form Submissions Map</h2>
    <hr />
    <b-row>
      <b-col cols="3">
        <b-form-select v-model="selected_cluster" :options="clusters" style="display: inline; margin-right: 50px;"></b-form-select>
      </b-col>
      <b-col cols="3">
        <b-form-select v-model="selected_form" :options="forms" style="display: inline; margin-right: 50px;"></b-form-select>
      </b-col>
      <b-col style="">
        <b-button variant="primary" @click="fetch_submissions" v-if="status_loading == false">Fetch Submissions</b-button>
        <b-button variant="primary" disabled v-else><i class="fa fa-spinner fa-spin"></i> Fetching Submissions</b-button>
      </b-col>
    </b-row>
    <br />
    <b-row>
      <b-col cols="3">
        <b-form-datepicker v-model="start_date" locale="en" :reset-button="true" placeholder="Starting Bound Date (None)"></b-form-datepicker>
      </b-col>
      <b-col cols="3">
        <b-form-datepicker v-model="end_date" locale="en" :reset-button="true" placeholder="Ending Bound Date (None)"></b-form-datepicker>
      </b-col>
    </b-row>
    <hr />

    <b-row>
      <b-col>
        <v-map ref="myMap" :zoom="7" :center="initialLocation" :options="{scrollWheelZoom: false}" style="height: 700px;">
          <v-tilelayer url="https://{s}.tile.osm.org/{z}/{x}/{y}.png"></v-tilelayer>
          <!-- <v-tilelayer url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"></v-tilelayer> -->

          <!-- <v-marker :lat-lng="[0.5736182,34.5356511]"></v-marker> -->
          <!-- <v-marker :lat-lng="[0.5736182,34.5356511]" :icon="icon"></v-marker> -->

          <!-- <v-circle :lat-lng="[0.5736182,34.5356511]" :radius="30000"></v-circle> -->
          <!-- <v-rectangle :bounds="bounds" :weight="1" :color="'#ff0000'"></v-rectangle> -->
        </v-map>
      </b-col>
      <b-col>
        <b-card no-body style="max-height: 700px; overflow: auto;">
          <b-tabs card fill>
            <b-tab :title="'OUT OF CLUSTER ('+out_bounds.length+')'" active>
              <b-card-text >
                <b-table 
                  :fields="table_fields" 
                  :per-page="out_perPage"
                  :current-page="out_currentPage" 
                  :items="out_bounds" 
                  @row-clicked="rowClicked" 
                  :tbody-tr-class="'clickable'" 
                  style="vertical-align: top; max-height: 700px;">

                </b-table>
                <b-pagination
                  v-model="out_currentPage"
                  :total-rows="out_bounds.length"
                  :per-page="out_perPage"
                  aria-controls="my-table"
                ></b-pagination>
              </b-card-text>
            </b-tab>
            <b-tab :title="'WITHIN CLUSTER ('+in_bounds.length+')'">
              <b-card-text >
                <b-table 
                  :fields="table_fields"  
                  :per-page="in_perPage"
                  :current-page="in_currentPage" 
                  :items="in_bounds" 
                  @row-clicked="rowClicked" 
                  :tbody-tr-class="'clickable'" 
                  style="vertical-align: top; max-height: 700px;">

                </b-table>
                <b-pagination
                  v-model="in_currentPage"
                  :total-rows="in_bounds.length"
                  :per-page="in_perPage"
                  aria-controls="my-table"
                ></b-pagination>
              </b-card-text>
            </b-tab>
            <b-tab :title="'MISSING GPS DATA ('+no_gps.length+')'">
              <b-card-text >
                <b-table  
                  :per-page="missing_perPage"
                  :current-page="missing_currentPage" 
                  :fields="table_fields" 
                  :items="no_gps"
                  style="vertical-align: top; max-height: 700px;">

                </b-table>
                <b-pagination
                  v-model="missing_currentPage"
                  :total-rows="no_gps.length"
                  :per-page="missing_perPage"
                  aria-controls="my-table"
                ></b-pagination>
              </b-card-text>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>

    <div class="tw-mt-auto tw-flex tw-justify-end">
      <info-popover>
        <template v-slot:title>
          Map
        </template>

        <p>Contains various points and regions of interest for the project.</p>
      </info-popover>
    </div>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
// import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import * as _ from "lodash";
import { LMap, LTileLayer } from "vue2-leaflet";
import { Icon, Marker, LayerGroup, polygon, latLngBounds, featureGroup } from "leaflet";
import * as moment from 'moment';

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

export default {
  mixins: [DashboardBaseTemplate],
  components: {
    "v-map": LMap,
    "v-tilelayer": LTileLayer,
    // "v-marker": LMarker,
    // "v-circle": LCircle,
    // "v-rectangle": LRectangle
  },
  props: {
  },
  data: function() {
    return {
      out_perPage: 10,
      out_currentPage: 1,
      in_perPage: 10,
      in_currentPage: 1,
      missing_perPage: 10,
      missing_currentPage: 1,
      selected_form: null,
      start_date: null,
      end_date: null,
      status_loading: false,
      forms: [
          { value: null, text: 'Please select a form type', disabled: true},
          { value: 'all', text: 'All Forms'},
      ],
      clusters: [
        { value: null, text: 'Please select a cluster', disabled: true},
        { value: 1, text: 'Cluster 1' },
        { value: 2, text: 'Cluster 2' },
        { value: 3, text: 'Cluster 3' },
        { value: 4, text: 'Cluster 4' },
        { value: 5, text: 'Cluster 5' },
        { value: 6, text: 'Cluster 6' },
        { value: 7, text: 'Cluster 7' },
        { value: 8, text: 'Cluster 8' },
        { value: 9, text: 'Cluster 9' },
        { value: 10, text: 'Cluster 10' },
        { value: 11, text: 'Cluster 11' },
        { value: 12, text: 'Cluster 12' },
        { value: 13, text: 'Cluster 13' },
        { value: 14, text: 'Cluster 14' },
        { value: 15, text: 'Cluster 15' },
        { value: 16, text: 'Cluster 16' },
        { value: 17, text: 'Cluster 17' },
        { value: 18, text: 'Cluster 18' },
        { value: 19, text: 'Cluster 19' },
        { value: 20, text: 'Cluster 20' },
        { value: 21, text: 'Cluster 21' },
        { value: 22, text: 'Cluster 22' },
        { value: 23, text: 'Cluster 23' },
        { value: 24, text: 'Cluster 24' },
        { value: 25, text: 'Cluster 25' },
        { value: 26, text: 'Cluster 26' },
        { value: 27, text: 'Cluster 27' },
        { value: 28, text: 'Cluster 28' },
        { value: 29, text: 'Cluster 29' },
        { value: 30, text: 'Cluster 30' },
        { value: 31, text: 'Cluster 31' },
        { value: 32, text: 'Cluster 32' },
        { value: 33, text: 'Cluster 33' },
        { value: 34, text: 'Cluster 34' },
        { value: 35, text: 'Cluster 35' },
        { value: 36, text: 'Cluster 36' },
        { value: 37, text: 'Cluster 37' },
        { value: 38, text: 'Cluster 38' },
        { value: 39, text: 'Cluster 39' },
        { value: 40, text: 'Cluster 40' },
        { value: 41, text: 'Cluster 41' },
        { value: 42, text: 'Cluster 42' },
        { value: 43, text: 'Cluster 43' },
        { value: 44, text: 'Cluster 44' },
        { value: 45, text: 'Cluster 45' },
        { value: 46, text: 'Cluster 46' },
        { value: 47, text: 'Cluster 47' },
        { value: 48, text: 'Cluster 48' },
        { value: 49, text: 'Cluster 49' },
        { value: 50, text: 'Cluster 50' },
        { value: 51, text: 'Cluster 51' },
        { value: 52, text: 'Cluster 52' },
        { value: 53, text: 'Cluster 53' },
        { value: 54, text: 'Cluster 54' },
        { value: 55, text: 'Cluster 55' },
        { value: 56, text: 'Cluster 56' },
        { value: 57, text: 'Cluster 57' },
        { value: 58, text: 'Cluster 58' },
        { value: 59, text: 'Cluster 59' },
        { value: 60, text: 'Cluster 60' }
      ],
      selected_cluster: null,
      initialLocation: [0.5064000000000988,34.2367000000001],
      bounds: [[0.8536182, 34.0356511], [0.2936182, 35.0356511]],
      icon: new Icon({iconUrl: 'https://leafletjs.com/examples/custom-icons/leaf-orange.png'}),
      // Other colors available at: https://github.com/pointhi/leaflet-color-markers
      rogueOne: new Icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      }),
      defaultIcon: new Icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-blue.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      }),
      plotted_submissions: [],
      submissions_received: [],
      in_bounds: [],
      out_bounds: [],
      no_gps: [],
      table_fields: [
        { key: "submitted_by", label: "User" },
        { key: "received_on", label: 'Submitted Time' },
        { key: "form_type" }
      ],
      submissions_layer: null,
      villagges_layer: null,
      village_collection: [],
      submissions_collection: []
    };
  },
  watch: {
    selected_cluster: function(val){
      let that = this;
      var bounds = latLngBounds([]);
      _.each(that.village_collection, function(item){
        if(item.item.cluster_number == val){
          item.polygon.setStyle({
            color: '#00CB00'
          });
          var layerBounds = item.polygon.getBounds();
          bounds.extend(layerBounds);
        }
        else{
          item.polygon.setStyle({
            color: '#3388ff'
          });
        }
      });

      // zoom into the village layer
      that.$refs.myMap.mapObject.fitBounds(bounds);
    }
  },
  computed: {
    // ...mapState('sample', ['sample'])
  },
  created: function() {},
  mounted: function() {
    this.$nextTick(() => {
      this.$refs.myMap.mapObject.fitBounds(this.bounds);
    });
    let that = this;

    HTTP.get("/kenya/forms/get_active_list").then(response => {
        _.each(response.data, function(item){
            that.forms.push({
                value: item.form_name,
                text: item.form_name
            });
        });
    });

    HTTP.get("/kenya/maps/get_cluster_villages").then(response => {
      let that = this;
      var bounds = latLngBounds([]);
      var villages = [];
      _.each(response.data, function(item){
          var village = polygon(item.polygon_normalized, {'item': item}).bindPopup('<b>Cluster:</b> '+item.cluster_number+'<br /><b>Village:</b> '+item.village_id).on('click', that.village_clicked);
          that.village_collection.push({
            item: item,
            polygon: village
          });
          villages.push(village);
          var layerBounds = village.getBounds();
          bounds.extend(layerBounds);
      });
      that.villagges_layer = new LayerGroup(villages);

      // add the village layer
      that.$refs.myMap.mapObject.addLayer(that.villagges_layer);

      // zoom into the village layer
      that.$refs.myMap.mapObject.fitBounds(bounds);
    });
  },
  methods: {
    get: function() {
    },
    village_clicked: function(village){
      this.selected_cluster = village.target.options.item.cluster_number;

    },
    fetch_submissions: function() {
        let that = this;
        that.status_loading = true;
        if(that.submissions_layer != null){
          that.submissions_layer.clearLayers();
        }
        that.no_gps = [];
        that.in_bounds = [];
        that.out_bounds = [];
        that.plotted_submissions = [];
        that.submissions_collection = [];
        HTTP.get("/kenya/maps/get_form_submissions?form_name="+that.selected_form+'&cluster='+that.selected_cluster+'&start_date='+that.start_date+'&end_date='+that.end_date).then(response => {
          if(response.data.length == 0){
            alert("No form submissions found.");
            that.status_loading = false;
            return;
          }
            var bounds = latLngBounds([]);
            
            _.each(response.data, function(item){
              // reformat the date/timestamp
              item.received_on = moment(item.received_on).format('MMM DD, YYYY @ hh:mm A');

              that.submissions_received.push(item);
              if(item.meta_gps == null){
                that.no_gps.push(item);
              }
              else{
                var coords = item.meta_gps;
                var new_point = new Marker([parseFloat(coords[0]), parseFloat(coords[1])], {icon: that.defaultIcon}).bindPopup('<b>'+item.form_type+'</b><br /><i>'+item.submitted_by+'</i><br />Received On: '+item.received_on);
                if(item.in_bounds == true){
                  that.in_bounds.push(item);
                }
                else{
                  that.out_bounds.push(item);
                  new_point = new Marker([parseFloat(coords[0]), parseFloat(coords[1])], {icon: that.rogueOne}).bindPopup('<b>'+item.form_type+'</b><br /><i>'+item.submitted_by+'</i><br />Received On: '+item.received_on);
                }
                
                that.plotted_submissions.push(new_point);

                that.submissions_collection.push({
                  marker: new_point,
                  item: item
                });
              }
            });
            that.submissions_layer = new LayerGroup(that.plotted_submissions);
            var submissions_group = new featureGroup(that.plotted_submissions);
            var layerBounds = submissions_group.getBounds();
            bounds.extend(layerBounds);
            that.$refs.myMap.mapObject.addLayer(that.submissions_layer);
            // zoom into the village layer
            that.$refs.myMap.mapObject.fitBounds(bounds);

            that.status_loading = false;
        });
    },
    rowClicked(record){
      let that = this;
      _.each(that.submissions_collection, function(item){
        if(item.item == record){
          that.$refs.myMap.mapObject.setView(item.marker.getLatLng(), 17);
          item.marker.openPopup();
        }
      });
    },
  }
};
</script>

<style>
@import "~leaflet/dist/leaflet.css";


.clickable {
  cursor: pointer;
}
</style>